// eslint-disable-next-line import/prefer-default-export
export const LocationAndJobFilterType = Object.freeze({
    LocationsAndJobs: 0,
    CostCenters: 1,
});

